<template>
    <input type="text" class="search-bar text-md rounded-lg block w-full py-3 px-4 mb-4"
        placeholder="Search for an integration" required v-model="search" />

    <div class="justify-top grid gap-4 grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4">
        <Integration v-for="i in filteredIntegrations.slice(0, 11)" :integration="i" hide-labels />

        <!-- <NuxtLink v-if="!filteredIntegrations.length"
            class="flex flex-nowrap border rounded-lg px-6 py-8 shadow-md hover:bg-[var(--hover-gray)]"
            to="/integrations" title="All integrations">
            <div class="flex-none w-12">
                <Icon name="tdesign:search-error"
                    class="w-full max-h-12 object-left-top object-contain rounded text-4xl text-red-400" />
            </div>
            <div class="overflow-hidden w-auto ml-6 flex items-center gap-4">
                <p class="font-semibold box-title">Not found!</p>
                <p class="text-gray-400 ">See all integrations</p>
            </div>
        </NuxtLink> -->
        <Integration v-if="filteredIntegrations.length > 11" :integration="more_integrations" hide-labels
            :href="moreHref" />
        <Integration v-else-if="!filteredIntegrations.length" :integration="no_integrations" hide-labels />
        <!--
        <NuxtLink to="/integrations" v-if="!filteredIntegrations.length || filteredIntegrations.length > 11">
            <button
                class="flex flex-nowrap box-title w-full h-full items-center justify-left border rounded-lg px-6 py-8 shadow-md hover:bg-[var(--hover-gray)]">

                <Icon v-if="!filteredIntegrations.length" name="tdesign:search-error"
                    class="w-full max-h-12 object-left-top object-contain rounded text-4xl text-red-400 mr-8" />
                <span v-if="!filteredIntegrations.length">not found</span>

                <div v-else>
                    <Icon name="fe:elipsis-h" class="text-gray-400 text-4xl mr-8" />
                    and more
                </div>
            </button>
        </NuxtLink>
    -->
    </div>
    <!-- </div> -->

</template>

<script lang="ts">
import { type PropType } from 'vue';
import { type TIntegrationCategory } from '~~/models/Unified';

type IntegrationCard = {
    type: string;
    name: string;
    logo_url?: string;
    fa_icon?: string;
    categories: TIntegrationCategory[];
    recent?: boolean;
    created_at?: string;
};

export default {
    props: {
        cat: {
            type: String as () => TIntegrationCategory,
            required: false,
        },
        cats: {
            type: Array as PropType<TIntegrationCategory[]>,
            required: false,
        },
        integrations: {
            type: Array as PropType<IntegrationCard[]>,
            required: true,
        },
    },
    setup() {
        return {
            more_integrations: { type: '', name: 'and more', fa_icon: 'fe:elipsis-h', categories: [] } as any,
            no_integrations: { type: '', name: 'Not Found - See All', fa_icon: 'tdesign:search-error', categories: [] } as any,
        }
    },
    computed: {
        filterCategories(): TIntegrationCategory[] {
            if (this.cats?.length) return this.cats;
            return this.cat ? [this.cat] : [];
        },
        // Link to the dedicated category page (/crm, /hris, ...) rather than the
        // duplicate /integrations?category= filter URL (TICKET-10398).
        moreHref(): string | undefined {
            return this.filterCategories.length === 1 ? `/${this.filterCategories[0]}` : undefined;
        },
        filteredIntegrations() {
            return this.integrations
                .filter((i) => this.filterCategories.some((c) => i.categories.includes(c)))
                .filter((i) => !this.search || i.type.includes(this.search));
        },
    },
    data() {
        return {
            search: '',
        };
    },
};
</script>